import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Routes from './Routes/routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Routes/>
);
